import gql from 'graphql-tag';

export const registerChangeAcademicData = gql`
  mutation registerChangeAcademicData(
    $registerChangeAcademicData: RegisterChangeAcademicDataRequest!
  ) {
    registerChangeAcademicData(request: $registerChangeAcademicData) {
      error
      requestId
    }
  }
`;

export const activateChangeAcademicData = gql`
  mutation activateChangeAcademicData(
    $procedureId: Float!
    $requestId: Float!
    $campus: String!
    $career: String!
  ) {
    activateChangeAcademicData(
      requestId: $requestId
      procedureId: $procedureId
      campus: $campus
      career: $career
    ) {
      error
      requestId
    }
  }
`;

export const cancelChangeAcademicData = gql`
  mutation cancelRequestChangeAcademicData(
    $procedureId: Float!
    $requestId: Float!
  ) {
    cancelRequestChangeAcademicData(
      requestId: $requestId
      procedureId: $procedureId
    ) {
      error
      requestId
    }
  }
`;
